module.exports = __webpack_public_path__ + "resources/81650d63a62a1b361cbafbb81cc9b3be.png";